const identityOptions = [
    { code: 1, text: "全栈开发者", value: "201", remark: "" },
    { code: 2, text: "后端开发者", value: "202", remark: "" },
    { code: 3, text: "前端开发者", value: "203", remark: "" },
    { code: 4, text: "产品经理", value: "204", remark: "" },
    { code: 5, text: "UI设计师", value: "205", remark: "" },
    { code: 6, text: "测试工程师", value: "206", remark: "" },
    { code: 7, text: "运维大师", value: "207", remark: "" },
    { code: 8, text: "架构师", value: "208", remark: "" },
    { code: 9, text: "算法工程师", value: "209", remark: "" },
    { code: 10, text: "销售大神", value: "210", remark: "" },
    { code: 11, text: "斜杠青年", value: "211", remark: "" },
    { code: -1, text: "其他", value: "212", remark: "" }
]
const identityOptionsRegister = [
    { code: 1, text: "全栈开发者", value: "201", remark: "" },
    { code: 2, text: "后端开发者", value: "202", remark: "" },
    { code: 3, text: "前端开发者", value: "203", remark: "" },
    { code: 4, text: "产品经理", value: "204", remark: "" },
    { code: 5, text: "UI设计师", value: "205", remark: "" },
    { code: 6, text: "测试工程师", value: "206", remark: "" },
    { code: 7, text: "运维大师", value: "207", remark: "" },
    { code: 8, text: "架构师", value: "208", remark: "" },
    { code: 9, text: "算法工程师", value: "209", remark: "" },
    { code: 10, text: "销售大神", value: "210", remark: "" },
]
const developLangOptions = [
    { code: 1, text: "Java", value: "301", remark: "" },
    { code: 2, text: "C", value: "302", remark: "" },
    { code: 3, text: "C++", value: "303", remark: "" },
    { code: 4, text: "C#", value: "304", remark: "" },
    { code: 5, text: "PHP", value: "305", remark: "" },
    { code: 6, text: "Script", value: "306", remark: "" },
    { code: 7, text: "JavaScript", value: "307", remark: "" },
    { code: 8, text: "VBScript", value: "308", remark: "" },
    { code: 9, text: "Perl", value: "309", remark: "" },
    { code: 10, text: "Python", value: "310", remark: "" },
    { code: 11, text: "HTML5", value: "311", remark: "" },
    { code: 12, text: "CSS", value: "312", remark: "" },
    { code: 13, text: "ColdFusion", value: "313", remark: "" },
    { code: 14, text: "JSP", value: "314", remark: "" },
    { code: 15, text: "MATLAB", value: "315", remark: "" },
    { code: 16, text: "Visual Basic .NET", value: "316", remark: "" },
    { code: 17, text: "ASP与.NET", value: "317", remark: "" },
    { code: 18, text: "Delph/Object Pascal", value: "318", remark: "" },
    { code: 19, text: "Visual Basic", value: "319", remark: "" },
    { code: 20, text: "Swift", value: "320", remark: "" },
    { code: 21, text: "Pascal", value: "321", remark: "" },
    { code: 22, text: "Groovy", value: "322", remark: "" },
    { code: 23, text: "Objective-C", value: "323", remark: "" },
    { code: 24, text: "Assembly language", value: "324", remark: "" },
    { code: 25, text: "Ruby Perl", value: "325", remark: "" },
    { code: 26, text: "R", value: "326", remark: "" },
    { code: 27, text: "PL/SQL", value: "327", remark: "" },
    { code: 28, text: "Node.js", value: "328", remark: "" },
    { code: -1, text: "其它", value: "329", remark: "" },
]
const industryOptions = [
    { code: 1, text: "餐饮", value: "801", remark: "" },
    { code: 2, text: "电商新零售", value: "802", remark: "" },
    { code: 3, text: "供应链管理", value: "803", remark: "" },
    { code: 4, text: "教育培训", value: "804", remark: "" },
    { code: 5, text: "ERP进销存", value: "805", remark: "" },
    { code: 6, text: "社群空间", value: "806", remark: "" },
    { code: 7, text: "人力资源", value: "807", remark: "" },
    { code: 8, text: "自动售货机", value: "808", remark: "" },
    { code: 9, text: "社区物业服务", value: "809", remark: "" },
    { code: -1, text: "其它", value: "810", remark: "" },
]
const domainOptions = [
    { code: 1, text: "电影", value: "6001", remark: "" },
    { code: 2, text: "心理学", value: "6002", remark: "" },
    { code: 3, text: "美食", value: "6003", remark: "" },
    { code: 4, text: "互联网", value: "6004", remark: "" },
    { code: 5, text: "旅行", value: "6005", remark: "" },
    { code: 6, text: "经济学", value: "6006", remark: "" },
    { code: 7, text: "商业", value: "6007", remark: "" },
    { code: 8, text: "金融", value: "6008", remark: "" },
    { code: 9, text: "生活", value: "6009", remark: "" },
    { code: 10, text: "法律", value: "6010", remark: "" },
    { code: 11, text: "汽车", value: "6011", remark: "" },
    { code: 12, text: "体育", value: "6012", remark: "" },
    { code: 13, text: "财务", value: "6013", remark: "" },
    { code: 14, text: "摄影", value: "6014", remark: "" },
    { code: 15, text: "健康", value: "6015", remark: "" },
    { code: 16, text: "科技", value: "6016", remark: "" },
    { code: 17, text: "游戏", value: "6017", remark: "" },
    { code: 18, text: "动漫", value: "6018", remark: "" },
    { code: 19, text: "职场", value: "6019", remark: "" },
    { code: 20, text: "科学", value: "6020", remark: "" },
    { code: 21, text: "影视", value: "6021", remark: "" },
    { code: 22, text: "设计", value: "6022", remark: "" },
    { code: 23, text: "教育", value: "6023", remark: "" },
    { code: 24, text: "阅读", value: "6024", remark: "" },
    { code: 25, text: "音乐", value: "6025", remark: "" },
    { code: 26, text: "文学", value: "6026", remark: "" },
    { code: 27, text: "艺术", value: "6027", remark: "" },
    { code: 28, text: "情感", value: "6028", remark: "" },
    { code: 29, text: "社会科学", value: "6029", remark: "" },
    { code: -1, text: "其它", value: "6030", remark: "" },
]
const hotCites = [{
        name: "北京市",
        tags: "BEIJING,北京市",
        cityid: 1,
    },
    {
        name: "上海市",
        tags: "SHANGHAI,上海市",
        cityid: 4,
    },
    {
        name: "广州市",
        tags: "GUANGZHOU,广州市",
        cityid: 3,
    },
    {
        name: "深圳市",
        tags: "SHENZHEN,深圳市",
        cityid: 2,
    },
    {
        name: "成都市",
        tags: "CHENGDU,成都市",
        cityid: 17,
    },
    {
        name: "重庆市",
        tags: "CHONGQING,重庆市",
        cityid: 18,
    },
    {
        name: "南京市",
        tags: "NANJING,南京市",
        cityid: 11,
    },
    {
        name: "杭州市",
        tags: "HANGZHOU,杭州市",
        cityid: 5,
    },
    {
        name: "长沙市",
        tags: "CHANGSHA,长沙市",
        cityid: 24,
    },
    {
        name: "石家庄市",
        tags: "SHIJIAZHUANG,石家庄市",
        cityid: 22,
    },
    {
        name: "天津市",
        tags: "TIANJIN,天津市",
        cityid: 7,
    },
    {
        name: "苏州市",
        tags: "SUZHOU,苏州市",
        cityid: 23,
    },
    {
        name: "福州市",
        tags: "FUZHOU,福州市",
        cityid: 34,
    },
    {
        name: "合肥市",
        tags: "HEFEI,合肥市",
        cityid: 15,
    },
    {
        name: "西安市",
        tags: "XIAN,西安市",
        cityid: 10,
    },
];
const projectStatusOptions = [
    { text: "本地开发", value: "901", remark: "" },
    { text: "远程可发", value: "902", remark: "" }
]
const projectTypeOptions = [
    { text: "B2B", value: "1201", remark: "" },
    { text: "B2C", value: "1202", remark: "" },
    { text: "B2B2C", value: "1203", remark: "" },
    { text: "CRM", value: "1204", remark: "" },
    { text: "ERP", value: "1205", remark: "" },
    { text: "C2C", value: "1206", remark: "" },
    { text: "S2B2C", value: "1207", remark: "" },
    { text: "O2O", value: "1208", remark: "" },
    { text: "其他", value: "1209", remark: "" }
]
const demandTypeOptions = [
    { text: "项目支持", value: "1102", remark: "" },
    { text: "UI支持", value: "1101", remark: "" },
    { text: "技术支持", value: "1103", remark: "" },
    { text: "商务支持", value: "1104", remark: "" },
]
const demandProjectTypeOptions = [
    { text: "B2B", value: "1201", remark: "" },
    { text: "B2C", value: "1202", remark: "" },
    { text: "B2B2C", value: "1203", remark: "" },
    { text: "CRM", value: "1204", remark: "" },
    { text: "ERP", value: "1205", remark: "" },
    { text: "C2C", value: "1206", remark: "" },
    { text: "S2B2C", value: "1207", remark: "" },
    { text: "O2O", value: "1208", remark: "" },
    { text: "其他", value: "1209", remark: "" }
]
module.exports = {
    identityOptionsRegister,
    identityOptions,
    developLangOptions,
    industryOptions,
    hotCites,
    projectStatusOptions,
    projectTypeOptions,
    demandTypeOptions,
    demandProjectTypeOptions,
    domainOptions
}
